import React from 'react'
import { sizes } from './const'
export interface WarningProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'
}

export const WarningIcon = ({
    className = 'js_WarningIcon',
    size = 'small',
}: WarningProps) => {
    return (
        <svg
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            stroke="currentColor"
        >
            <path
                opacity={0.2}
                d="M7.13752 2.50016L1.63752 12.0002C1.5499 12.1519 1.5037 12.324 1.50354 12.4993C1.50339 12.6745 1.54928 12.8467 1.63663 12.9986C1.72399 13.1506 1.84972 13.2768 2.00125 13.3649C2.15278 13.4529 2.32478 13.4995 2.50002 13.5002H13.5C13.6753 13.4995 13.8473 13.4529 13.9988 13.3649C14.1503 13.2768 14.2761 13.1506 14.3634 12.9986C14.4508 12.8467 14.4967 12.6745 14.4965 12.4993C14.4963 12.324 14.4501 12.1519 14.3625 12.0002L8.86252 2.50016C8.77556 2.3482 8.64999 2.22192 8.49853 2.13409C8.34707 2.04626 8.1751 2 8.00002 2C7.82494 2 7.65296 2.04626 7.5015 2.13409C7.35005 2.22192 7.22448 2.3482 7.13752 2.50016Z"
                fill="#CC0000"
            />
            <path
                d="M8 7V9"
                stroke="#CC0000"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.13752 2.50016L1.63752 12.0002C1.5499 12.1519 1.5037 12.324 1.50354 12.4993C1.50339 12.6745 1.54928 12.8467 1.63663 12.9986C1.72399 13.1506 1.84972 13.2768 2.00125 13.3649C2.15278 13.4529 2.32478 13.4995 2.50002 13.5002H13.5C13.6753 13.4995 13.8473 13.4529 13.9988 13.3649C14.1503 13.2768 14.2761 13.1506 14.3634 12.9986C14.4508 12.8467 14.4967 12.6745 14.4965 12.4993C14.4963 12.324 14.4501 12.1519 14.3625 12.0002L8.86252 2.50016C8.77556 2.3482 8.64999 2.22192 8.49853 2.13409C8.34707 2.04626 8.1751 2 8.00002 2C7.82494 2 7.65296 2.04626 7.5015 2.13409C7.35005 2.22192 7.22448 2.3482 7.13752 2.50016V2.50016Z"
                stroke="#CC0000"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12Z"
                fill="#CC0000"
            />
        </svg>
    )
}
